// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_page_wrapper__sPeNR","left":"search_page_left__dViWp","right":"search_page_right__1AmlX"};